function redirect(url: string, openInNewTab?: boolean) {
  if (openInNewTab) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
}

export { redirect };
